export default function getValueFromPath(obj, path) {
    return path.split('.').reduce((accumulator, key) => {
        if (accumulator !== null && key in accumulator) {
            return accumulator[key];
        } else {
            return null;
        }
    }, obj);
}